module.exports = __webpack_public_path__ + "img/export.dfa12a30.svg";